import { render, staticRenderFns } from "./user-search-field.vue?vue&type=template&id=482c84ec&scoped=true"
import script from "./user-search-field.vue?vue&type=script&lang=js"
export * from "./user-search-field.vue?vue&type=script&lang=js"
import style0 from "./user-search-field.vue?vue&type=style&index=0&id=482c84ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482c84ec",
  null
  
)

export default component.exports